import { ThunkType } from "../../../../../core/store/reducers";
import { setData } from "../tradeByProductsDataSlice";
import getTradeByProductsDataApi from "../api/getTradeByProductsData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.exchbusiness.tradeByProducts;

  const pagedTrades = await dispatch(getTradeByProductsDataApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
